export class SpareInOut {

    id: string = null;
    from: string = null;
    to: string = null;
    item: string = null;
    qty: number = null;
    reason: string = null;
    created: Date = null;
    type : string = null;
    powerTrainId : string = null;
    motorId : string = null;

    getId() {
        return this.id;
    }

    getPowerTrainId() {
        return this.powerTrainId;
    }

    getMotorId() {
        return this.motorId;
    }

    getFrom() {
        return this.from;
    }

    getTo() {
        return this.to;
    }

    getItem() {
        return this.item;
    }

    getQty() {
        return this.qty;
    }

    getReason() {
        return this.reason;
    }

    getCreated() {
        return this.created;
    }

    setId(id: string) {
        this.id = id;
    }

    setPowerTrainId(id: string) {
        this.powerTrainId = id;
    }

    setMotorId(id: string) {
        this.motorId = id;
    }

    setFrom(from: string) {
        this.from = from;
    }

    setTo(to: string) {
        this.to = to;
    }

    setItem(item: string) {
        this.item = item;
    }

    setQty(qty: number) {
        this.qty = qty;
    }

    setReason(reason: string) {
        this.reason = reason;
    }

    setType(t: string) {
        this.type = t;
    }

    reset() {
        this.id = null;
        this.from = null;
        this.to = null;
        this.item = null;
        this.qty = null;
        this.reason = null;
        this.type = null;
        this.powerTrainId = null;
        this.motorId = null;
    }

}